import { fromUTCtoLocalTime } from './TimeLimitUtils';
import type { RepeatingTimeLimit, TimeLimitHandler } from './types';

function findClosestRepeatingDate(startDate: number, repeatsEvery: number): number {
  if (Date.now() < startDate) {
    return startDate;
  }
  return startDate + Math.floor((Date.now() - startDate) / repeatsEvery) * repeatsEvery;
}

export class RepeatingTimeLimitHandler implements TimeLimitHandler {
  constructor(private readonly timeLimit: RepeatingTimeLimit) {}

  public canStart(): boolean {
    if (this.timeLimit.startedAt) return false;
    const startDateOk = this.getStartDate() <= Date.now();
    const endDateOk = this.getEndDate() >= Date.now();
    return startDateOk && endDateOk;
  }

  public getEndDate(): number {
    if (this.timeLimit.startedAt) {
      return this.timeLimit.startedAt + this.timeLimit.duration;
    }

    return this.getStartDate() + this.timeLimit.duration;
  }

  public getStartDate(): number {
    if (this.timeLimit.startedAt) {
      return this.timeLimit.startedAt;
    }

    const startDate = this.timeLimit.toLocalTime
      ? fromUTCtoLocalTime(this.timeLimit.startDate)
      : this.timeLimit.startDate;

    if (startDate > Date.now()) {
      return startDate;
    }

    return findClosestRepeatingDate(startDate, this.timeLimit.repeatsEvery);
  }

  public hasEnded(): boolean {
    return this.getEndDate() < Date.now();
  }
}
